import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#FFFFFF",
    display: "flex",
    flexDirection: "row",
    padding: "37px",
    // minHeight: "100%",
  },
  fields: {
    maxWidth: 600,
    width: "100%",
  },
  field: {
    marginBottom: 20,
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  inputDescription: {
    backgroundColor: "#F4F4F4",
    borderRadius: "4px",
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    paddingLeft: "10px",
    paddingRight: "10px",
    "&.Mui-focused": {
      backgroundColor: "rgba(0, 0, 0, 0.09)",
    },
  },
  courses: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "1024px",
  },
  verticalContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
}))

export default styles
